<template>  
  <div class="weather-wrapper">
    <div class="weather-top">
      <span v-if="pageData.province">{{pageData.province?pageData.province:pageData.province}}</span>
      <span v-if="pageData.city">{{pageData.city?pageData.city:pageData.city}}</span>
      <span v-if="pageData.area">{{pageData.area?pageData.area:pageData.area}}</span>
    </div>
    <div class="weather-bottom clearfix">
      <div class="weather-bottom-left">
        <span>{{weatherData.weather}}</span>
        <!-- <span>多云</span> -->
      </div>
      <div class="weather-bottom-right">
        <div
        v-if="weatherData.temperature||weatherData.temperature==0"
        class="weather-content-right"
      >{{weatherData.temperature}}℃</div>      
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    pageData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      weatherData: {},
      weekDay: "",
      weatherIconList: [],
      weatherList: [
        "晴", //0
        "多云", //1
        "阴", //2
        "阵雨", //3
        "雷阵雨", //4无
        "雷阵雨并伴有冰雹", //5
        "雨夹雪", //6
        "小雨", //7
        "中雨", //8
        "大雨", //9
        "暴雨", //10
        "大暴雨", //11
        "特大暴雨", //12
        "阵雪", //13
        "小雪", //14
        "中雪", //15
        "大雪", //16
        "暴雪", //17
        "雾", //18
        "冻雨", //19
        "沙尘暴", //20
        "小雨-中雨", //21
        "中雨-大雨", //22
        "大雨-暴雨", //23
        "暴雨-大暴雨", //24
        "大暴雨-特大暴雨", //25
        "小雪-中雪", //26
        "中雪-大雪", //27
        "大雪-暴雪", //28
        "浮尘", //29
        "扬沙", //30
        "强沙尘暴", //31
        "飑", //32
        "龙卷风", //33
        "弱高吹雪", //34
        "轻雾", //35
        "霾" //36
      ]
    };
  },
  computed: {
    weatherIndex() {
      return this.weatherList.indexOf(this.weatherData.weather)
      // return 25;
    }
  },
  created() {
    let _this = this;
    let arr = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    let date = new Date().getDay();
    this.weekDay = arr[date];
    if (this.pageData.province) {
      AMap.plugin("AMap.Weather", function() {
        var weather = new AMap.Weather();
        //查询实时天气信息, 查询的城市到行政级别的城市，如朝阳区、杭州市
        weather.getLive(_this.pageData.provinceCode, function(err, data) {
          //   console.log(data);
          if (data.weather) {
            _this.weatherData = data;
            if (_this.pageData.cityCode) {
              weather.getLive(_this.pageData.cityCode, function(err, data) {
                // console.log(data);
                if (data.weather) {
                  if (_this.pageData.areaCode) {
                    weather.getLive(_this.pageData.areaCode, function(
                      err,
                      data
                    ) {
                      //   console.log(data);
                      if (data.weather) {
                        _this.weatherData = data;
                      }
                    });
                  }
                }
              });
            }
          }
        });
      });
    }
  },
  destroyed() {},
  methods: {
    getMeather(code) {
      let _this = this;
      AMap.plugin("AMap.Weather", function() {
        var weather = new AMap.Weather();
        //查询实时天气信息, 查询的城市到行政级别的城市，如朝阳区、杭州市
        weather.getLive(code, function(err, data) {
          // console.log(data)
          if (!err) {
            // console.log(data);
            if (!data.temperature) {
            } else {
              _this.weatherData = data;
              return false;
            }
          }
        });
      });
    },
    preview(src, e) {
      // do something
    },
    navigate(href, e) {
      // do something
    }
  }
};
</script>
<style lang="scss" scoped>
.weather-wrapper{
  height: 40px;
  
  .weather-top{
    font-size: 16px;
    color: #413838;
    
  }
  .weather-bottom{
    overflow: hidden;
    .weather-bottom-left{
      float: left;
      font-size: 12px;
      color: #413838;
    }
    .weather-bottom-right{
      float: left;
      font-size: 12px;
      color: #413838;
      margin-left: 10px;
    } 
  }
}
.weather-wrapper:after{
  content: '';
  width: 0;
  height: 100%;
  display: inline-block;
  vertical-align: middle;
}
</style>




// WEBPACK FOOTER //
// src/components/custompage/customComponent/weather.vue